import { useMemo, useState } from 'react';
import { Alert, Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router';
import authService from '../../services/authService';

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const email = params.get('email') ?? '';
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const canSubmit = useMemo(
    () => !!email && !!token && password.length >= 8 && password === confirm,
    [email, token, password, confirm]
  );

  const submit = async () => {
    setBusy(true);
    setError('');
    try {
      await authService.resetPassword(email, token, password);
      setDone(true);
    } catch (e: any) {
      setError(e?.response?.data?.message ?? 'Sikertelen jelszócsere');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
      <Paper sx={{ p: 3, width: 420, maxWidth: '95%' }}>
        <Typography variant="h5" gutterBottom>
          Új jelszó megadása
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {done ? (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>
              Jelszó sikeresen módosítva.
            </Alert>
            <Button variant="contained" onClick={() => navigate('/')}>
              Bejelentkezés
            </Button>
          </>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField label="Email" value={email} disabled fullWidth />
            <TextField
              label="Új jelszó"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
            />
            <TextField
              label="Új jelszó mégegyszer"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              fullWidth
            />
            <Button
              variant="contained"
              disabled={!canSubmit || busy}
              onClick={submit}
            >
              Mentés
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default ResetPasswordPage;
